<!-- =========================================================================================
  File Name: ECommerceCheckout.vue
  Description: eCommerce Checkout page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="ecommerce-checkout-demo">
        <form-wizard
            ref="checkoutWizard"
            color="rgba(var(--vs-primary), 1)"
            :title="null"
            :subtitle="null"
            :hide-buttons="true">

            <!-- tab 1 content -->
            <tab-content title="장바구니" icon="feather icon-shopping-cart" class="mb-5">

                <!-- IF CART HAVE ITEMS -->
                <div class="vx-row" v-if="cartItems.length">

                    <!-- LEFT COL -->
                    <div class="vx-col lg:w-2/3 w-full relative">
                        <div class="items-list-view" v-for="(item, index) in cartItems" :key="item.objectID">
                            <item-list-view :item="item" class="mb-base">

                                <!-- SLOT: ITEM META -->
                                <template slot="item-meta">
                                    <h6
                                      class="item-name font-semibold mb-1 cursor-pointer hover:text-primary">{{ item.productName }}</h6>
                                    <p class="text-sm mb-2">By <span class="font-semibold cursor-pointer">{{ item.brandName }}</span></p>
                                    <!-- <p class="text-success text-sm">{{ item.courseName }}</p> -->

                                    <p class="mt-4 font-bold text-sm">수량</p>
                                    <vs-input-number min="1" :value="item.orderCount" @input="updateItemQuantity($event, index)" class="inline-flex" />

                               </template>

                                <!-- SLOT: ACTION BUTTONS -->
                                <template slot="action-buttons">

                                    <!-- PRIMARY BUTTON: REMOVE -->
                                    <div class="item-view-primary-action-btn p-3 rounded-lg flex flex-grow items-center justify-center cursor-pointer mb-3" @click="deleteItemFromCart(item)">
                                        <feather-icon icon="XIcon" svgClasses="h-4 w-4" />
                                        <span class="text-sm font-semibold ml-2">삭제</span>
                                    </div>
                                </template>
                            </item-list-view>
                        </div>
                    </div>

                    <!-- RIGHT COL -->
                    <div class="vx-col lg:w-1/3 w-full">
                        <vx-card>

                            <p class="font-semibold mb-3">주문금액</p>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">총 교재수량</span>
                                <span>{{ totalOrderCount }}</span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">총 할인금액</span>
                                <span class="text-danger">-0원</span>
                            </div>

                            <vs-divider />

                            <div class="flex justify-between font-semibold mb-3">
                                <span>총 주문금액</span>
                                <span class="text-primary">{{ buyMoney }}원</span>
                            </div>

                            <vs-button class="w-full" @click="$refs.checkoutWizard.nextTab()">다음 단계</vs-button>
                        </vx-card>
                    </div>
                </div>

                <!-- IF NO ITEMS IN CART -->
                <vx-card title="장바구니가 비었습니다." v-else>
                    <vs-button @click="$router.push('/order/product-list').catch(() => {})">장바구니 담기</vs-button>
                </vx-card>

            </tab-content>

            <!-- tab 2 content -->
            <tab-content title="배송지" icon="feather icon-home" class="mb-5">

                <div class="vx-row">

                    <!-- LEFT COL: NEW ADDRESS -->
                    <div class="vx-col lg:w-2/3 w-full">
                        <vx-card title="배송지 정보" subtitle="배송지 정보를 입력해주세요." class="mb-base">

                            <form data-vv-scope="add-new-address">
                                <div class="vx-row">
                                    <div class="vx-col sm:w-1/2 w-full">

                                        <vs-select autocomplete label="학원명" v-model="institute" class="w-full mt-5">
                                            <vs-select-item :key="index" :value="item.instituteSeq" :text="item.instituteName" v-for="(item,index) in instituteOptions" />
                                        </vs-select>
                                    </div>

                                    <div class="vx-col sm:w-1/2 w-full">

                                        <vs-input
                                            v-validate="'required'"
                                            data-vv-as="수령인"
                                            name="presidentName"
                                            label="수령인"
                                            v-model="institute_data.presidentName"
                                            class="w-full mt-5" />
                                        <span v-show="errors.has('add-new-address.presidentName')" class="text-danger">{{ errors.first('add-new-address.presidentName') }}</span>
                                    </div>

                                </div>

                                <div class="vx-row">


                                    <div class="vx-col sm:w-1/2 w-full">

                                        <vs-input
                                            v-validate="'required'"
                                            data-vv-as="전화번호"
                                            name="telephone"
                                            label="전화번호"
                                            v-model="institute_data.telephone"
                                            class="w-full mt-5" />
                                        <span v-show="errors.has('add-new-address.telephone')" class="text-danger">{{ errors.first('add-new-address.telephone') }}</span>
                                    </div>

                                    <div class="vx-col sm:w-1/2 flex flex-wrap">
                                        <div class="w-1/2">

                                          <vs-input 
                                              disabled
                                              v-validate="'required'"
                                              data-vv-as="우편번호"
                                              name="zipCode"
                                              label="우편번호" 
                                              v-model="institute_data.zipCode" 
                                              class="w-full mt-5" />
                                          <span v-show="errors.has('add-new-address.zipCode')" class="text-danger">{{ errors.first('add-new-address.zipCode') }}</span>                                  
                                        </div>
                                        <div class="w-1/2">
                                          <vs-button class="mt-10 ml-4" @click="popupActive=true">주소 검색</vs-button>
                                        </div>
                                     </div>

                                </div>

                                <div class="vx-row">

                                    <div class="vx-col sm:w-1/2 w-full">

                                        <vs-input
                                            v-validate="'required'"
                                            data-vv-as="휴대번호"
                                            name="mobilephone"
                                            label="휴대번호"
                                            v-model="institute_data.mobilephone"
                                            class="w-full mt-5" />
                                        <span v-show="errors.has('add-new-address.mobilephone')" class="text-danger">{{ errors.first('add-new-address.mobilephone') }}</span>
                                    </div>

                                    <div class="vx-col sm:w-1/2 w-full">
          
                                        <vs-input
                                            v-validate="'required'"
                                            data-vv-as="주소"
                                            disabled
                                            name="zipName"
                                            label="주소"
                                            v-model="institute_data.zipName"
                                            class="w-full mt-5" />
                                        <span v-show="errors.has('add-new-address.zipName')" class="text-danger">{{ errors.first('add-new-address.zipName') }}</span>
                                    </div>
                                </div>

                                <div class="vx-row">

                                    <div class="vx-col sm:w-1/2 w-full">

                                        <vs-input
                                            v-validate="'email'"
                                            data-vv-as="이메일"
                                            name="email"
                                            label="이메일"
                                            v-model="institute_data.eMail"
                                            class="w-full mt-5" />
                                        <span v-show="errors.has('add-new-address.email')" class="text-danger">{{ errors.first('add-new-address.email') }}</span>
                                    </div>

                                    <div class="vx-col sm:w-1/2 w-full">

                                        <vs-input
                                            name="zipDetail"
                                            label="주소세부"
                                            v-model="institute_data.zipDetail"
                                            class="w-full mt-5" />
                                        <span v-show="errors.has('add-new-address.zipDetail')" class="text-danger">{{ errors.first('add-new-address.zipDetail') }}</span>
                                    </div>

                                </div>
                                <!-- <vs-button class="mt-6 ml-auto flex" @click.prevent="submitNewAddressForm">SAVE AND DELIVER HERE</vs-button> -->
                            </form>
                        </vx-card>
                    </div>

                    <!-- RIGHT COL: CONTINUE WITH SAVED ADDRESS -->
                    <div class="vx-col lg:w-1/3 w-full">
                        <vx-card title="주문자 정보">
                            <div>
                                <table>
                                  <tr>
                                    <td class="font-semibold">주문자</td>
                                    <td>{{ activeUserInfo.name  }}</td>
                                  </tr>
                                  <tr>
                                    <td class="font-semibold">학원명</td>
                                    <td>{{ activeUserInfo.instituteName }}</td>
                                  </tr>
                                  <tr>
                                    <td class="font-semibold">주소</td>
                                    <td>{{ activeUserInfo.zipCode }} {{activeUserInfo.zipName }} {{ activeUserInfo.zipDetail }}</td>
                                  </tr>
                                  <tr>
                                    <td class="font-semibold">전화번호</td>
                                    <td>{{ activeUserInfo.telephone }}</td>
                                  </tr>
                                    <tr>
                                    <td class="font-semibold">휴대폰번호</td>
                                    <td>{{ activeUserInfo.mobilephone }}</td>
                                  </tr>
                                    <tr>
                                    <td class="font-semibold">이메일</td>
                                    <td>{{ activeUserInfo.eMail }}</td>
                                  </tr>
                                </table>
                            </div>

                            <vs-divider />

                            <vs-button class="w-full" :disabled="!validateDeliveryForm" @click="$refs.checkoutWizard.nextTab()">다음 단계</vs-button>
                        </vx-card>
                    </div>

                </div>
            </tab-content>

            <!-- tab 3 content -->
            <tab-content title="결제정보" icon="feather icon-credit-card" class="mb-5">

                <div class="vx-row">

                    <!-- LEFT COL: 주문 정보 -->
                    <div class="vx-col lg:w-2/3 w-full">
                        <vx-card title="주문 정보" subtitle="주문하기 버튼을 눌러야만 완료 처리가 되어 본사에서 확인이 됩니다." class="mb-base">

                            <div class="mt-3">
                                <vs-table :data="cartItems">

                                <template slot="thead">
                                  <vs-th>교재명</vs-th>
                                  <vs-th>교재단가(권 당)</vs-th>
                                  <vs-th>수량</vs-th>
                                  <vs-th>교재합계</vs-th>
                                </template>

                                <template slot-scope="{data}">
                                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                                    <vs-td :data="data[indextr].productName">
                                      {{ data[indextr].productName }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].price">
                                      {{ String(data[indextr].price).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}원
                                    </vs-td>

                                    <vs-td :data="data[indextr].orderCount">
                                      {{ data[indextr].orderCount }}
                                    </vs-td>

                                    <vs-td>
                                      {{ String(data[indextr].price * data[indextr].orderCount).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}원
                                    </vs-td>

                                  </vs-tr>
                                </template>

                              </vs-table>

                            </div>

                            <div class="mt-5">
                              <div>주문 특이 사항</div>
                              <vs-textarea v-model="orderMemo" />
                            </div>
                            <vs-alert active="true" class="" icon-pack="feather" icon="icon-star">
                              정상적인 주문 이외에 특이사항이 있는 주문내역이나 교재담당에게 주지시켜야 할 내용을 기록합니다.
                            </vs-alert>

                        </vx-card>
                    </div>

                    <!-- RIGHT COL: 결제 정보 -->
                    <div class="vx-col lg:w-1/3 w-full">
                        <vx-card title="결제금액">

                            <div class="flex justify-between mb-2">
                                <span>총 상품금액</span>
                                <span class="font-semibold">{{ buyMoney }}원</span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span>배송비</span>
                                <span class="text-success">{{ deliveryCharges }}</span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span>총 할인금액</span>
                                <span class="text-danger">-0원</span>
                            </div>

                            <vs-divider />

                            <div class="flex justify-between font-semibold">
                                <span>총 결제 금액</span>
                                <span class="text-primary">{{ realTakeMoney }}원</span>
                            </div>
                        </vx-card>

                         <vx-card title="결제 정보" subtitle="아래 계좌 중 선택하여 송금해 주세요.">
                            
                            <div>계좌 번호</div>
                            <div class="mb-2">
                              <table>
                                <tr>
                                  <td class="font-semibold">기업 / (주)엘이디에듀</td>
                                </tr>
                                <tr>
                                  <td>221-328695-04-016</td>
                                </tr>
                              </table>
                            </div>

                            <vs-divider />

                            <vs-button class="w-full" @click="confirmSave">주문하기</vs-button>
                            
                        </vx-card>
                    </div>

                </div>
            </tab-content>

        </form-wizard>
      <!-- Daum 우편번호 서비스 -->
      <vs-popup class="holamundo" title="주소 검색" :active.sync="popupActive">
        <p>
          <vue-daum-postcode @complete="this.daumPostCode" />
        </p>
      </vs-popup>
    </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
const ItemListView = () => import('./components/ItemListView.vue')

import { VueDaumPostcode } from 'vue-daum-postcode'
import { fetchData, putData, postData, deleteData } from '@/api/module'

export default { 
  data () {
    return {
      //TAB 1
      userID: this.$store.getters.getUserInfo.userID,

      // TAB 2
      popupActive: false,
      institute: this.$store.getters.getUserInfo.instituteSeq,
      instituteOptions: [],
      institute_data: {},

      // TAB 3
      orderMemo: '',
      paymentMethod: 'debit-card',
      cvv: ''
    }
  },
  watch: {
    institute () {
      this.loadIntituteInfo()
    }
  },
  computed: {
    // TAB 1
    cartItems () {
      return this.$store.state.cartItems.slice().reverse()
    },
    totalOrderCount () {
      let count = 0
      this.cartItems.forEach(item => {
        count += item.orderCount
      })
      return count
    },
    buyMoney () {
      let price = 0
      this.cartItems.forEach(item => {
        const result =  item.orderCount * item.price
        price += result
      })
      return `${String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
    },

    // TAB 2
    activeUserInfo () {
      return this.$store.getters.getUserInfo
    },
    validateDeliveryForm () {
      return this.institute_data.telephone && this.institute_data.mobilephone && this.institute_data.eMail
      && this.institute_data.presidentName && this.institute_data.zipCode && this.institute_data.zipName
      // return !this.$validator.validateAll('add-new-address')
    },
    isPayDiliveryCharge () {
      
      let deliveryCharge = false
      for (let i = 0; i < this.cartItems.length; i++) {
        if (this.cartItems[i].productType === 0) {
          deliveryCharge = true
          break
        }
      }
      return deliveryCharge
    },
    deliveryCharges () {

      if (this.isPayDiliveryCharge) {
        //const buyMoney = Number(this.buyMoney.replace(/,/g, ''))
        //if (buyMoney > 250000) {
        // return '무료배송'
        //} else {
        return `${String(3000).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원`
        //}
      } else {
        return '무료배송'
      }
    },
    realTakeMoney () {
      const buyMoney = Number(this.buyMoney.replace(/,/g, ''))
      let deliveryCharges = this.deliveryCharges.split('원')[0]
      if (deliveryCharges === '무료배송') {
        deliveryCharges = 0
      } else {
        deliveryCharges =  Number(deliveryCharges.replace(/,/g, ''))
      }
      const result = buyMoney + deliveryCharges

      return `${String(result).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
    }
  },
  methods: {
    // TAB 1
    async deleteItemFromCart (item) {

      try {
        const orderBasketSeq = item.orderBasketSeq
        const orderBasketItemSeq = item.orderBasketItemSeq
        await deleteData(`order/${orderBasketSeq}/basket/${orderBasketItemSeq}`)
        this.$store.dispatch('loadCartItems', this.userID)

      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    async updateItemQuantity (event, index) {
      const orderBasketItemSeq = this.cartItems[index].orderBasketItemSeq
      const orderCount = event

      try {
        await putData(`order/${orderBasketItemSeq}/basket/${orderCount}`)
        this.$store.dispatch('loadCartItems', this.userID)

      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },

    // TAB 2
    async loadInstituteList () {

      try {
        const keyword = ''
        const { data } = await fetchData('institute/search', keyword)
        this.instituteOptions = data.list

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    async loadIntituteInfo () {

      try {
        const { data } = await fetchData(`institute/${this.institute}`)
        this.institute_data = data.data

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    daumPostCode (value) {
      this.institute_data.zipCode = value.zonecode
      this.institute_data.zipName = value.address

      this.popupActive = false
    },

    // TAB 3
    confirmSave () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '주문하기',
        text: '주문 하시겠습니까?',
        accept: this.save,
        acceptText: '주문'
      })
    },
    async save () {

      try {

        await postData('order', {
          assignType: 1,
          branchSeq: 1,
          branchName: '본사(임시지사)',
          orderUserID : this.activeUserInfo.userID,
          orderUserName : this.activeUserInfo.name,
          orderUserPhone : this.activeUserInfo.telephone,
          orderUserSMSPhone : this.activeUserInfo.mobilephone,
          orderUserEmail : this.activeUserInfo.eMail,
          instituteSeq : this.institute_data.instituteSeq,
          instituteName : this.institute_data.instituteName,
          buyMoney : this.buyMoney.replace(/,/g, ''),
          realTakeMoney : this.realTakeMoney.replace(/,/g, ''),
          recvUserName : this.institute_data.presidentName,
          recvUserPhone : this.institute_data.telephone,
          recvUserSMSPhone : this.institute_data.mobilephone,
          recvUserEmail : this.institute_data.eMail,
          recvZipCode : this.institute_data.zipCode,
          recvZipName : this.institute_data.zipName,
          recvZipDetail : this.institute_data.zipDetail,
          businessNumber : this.institute_data.businessNumber,
          orderMemo : this.orderMemo,
          
          orderProductList : this.cartItems
          
        })

        this.$router.push('/ordersheet/ordersheet-list')
        this.showSaveSuccess()

      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    showSaveSuccess () {
      this.$vs.notify({
        color: 'success',
        title: '주문하기',
        text: '완료 되었습니다.'
      })
    }
  },
  created () {
    this.loadInstituteList()
    this.loadIntituteInfo()
  },
  components: {
    ItemListView,
    FormWizard,
    TabContent,
    VueDaumPostcode
  }
 
}
</script>

<style lang="scss" scoped>
#ecommerce-checkout-demo {
    .item-view-primary-action-btn {
        color: #2c2c2c !important;
        background-color: #f6f6f6;
    }

    .item-name {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        -webkit-line-clamp: 2;
    }

    .vue-form-wizard {
        padding-bottom: 0;

        ::v-deep .wizard-header {
            padding: 0;
        }

        ::v-deep .wizard-tab-content {
            padding-right: 0;
            padding-left: 0;
            padding-bottom: 0;

            .wizard-tab-container{
              margin-bottom: 0 !important;
            }
        }
    }
}
</style>
